export const DeduplicationPharmacy = {
    path: '/deduplication/pharmacy',
    name: 'deduplication.pharmacy',
    component: () => import('@/views/Identical/DeduplicationPharmacyPage.vue'),
    children: [
        {
            path: '/deduplication/pharmacy/edit/:id',
            name: 'deduplication.pharmacy.edit',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {updateAction: true, type: 'pharmacy'},
        },
        {
            path: '/deduplication/pharmacy/delete/:id',
            name: 'deduplication.pharmacy.delete',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {deleteAction: true, type: 'pharmacy'},
        },
        {
            path: '/deduplication/pharmacy/view/:id',
            name: 'deduplication.pharmacy.view',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {viewAction: true, type: 'pharmacy'},
        },
        {
            path: '/deduplication/pharmacy/visit/view/:id',
            name: 'deduplication.pharmacy.visit.view',
            component: () => import('@/views/Visit/Form/VisitForm.vue'),
            props: {viewAction: true, type: 'pharmacy'},
        },
    ]
}